import { useEffect } from "react";
import {language} from "../i18n";
import i18n from "i18next";


const UseLanguageDetectorHook = (languageParam) => {

  useEffect(() => {

    const html = document.getElementsByTagName("html")[0];
    if (languageParam === "ar") {
      html.setAttribute("dir", "rtl");
      document.documentElement.lang = i18n.language;
      language.language = "ar";
    } else {
      html.setAttribute("dir", "ltr");
      document.documentElement.lang = i18n.language;
      language.language = "en";
    }
  }, [languageParam]);


  return language
}

export default UseLanguageDetectorHook
